import { createContext, useCallback, useContext, useMemo, useState } from "react";

export const COUNTRIES = ["UK", "Nigeria"];

const STORAGE_KEY = "aquaviva_country";

// Safe default, so pages don't crash if the provider is ever missing
const CountryContext = createContext({ country: "UK", setCountry: () => {} });

function readStoredCountry() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return COUNTRIES.includes(saved) ? saved : "UK";
  } catch {
    return "UK";
  }
}

export function CountryProvider({ children }) {
  const [country, setCountryState] = useState(readStoredCountry);

  const setCountry = useCallback((next) => {
    if (!COUNTRIES.includes(next)) return;
    setCountryState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // storage unavailable: the choice still works for this visit
    }
  }, []);

  const value = useMemo(() => ({ country, setCountry }), [country, setCountry]);

  return <CountryContext.Provider value={value}>{children}</CountryContext.Provider>;
}

export const useCountry = () => useContext(CountryContext);